import React from 'react';
import './css/videos-container.css';
import PropTypes from "prop-types";
import VideoContainer from "./VideoContainer";
import UploadVideoContainer from "./UploadVideoContainer";

function VideosContainer({videos, removeVideoById}) {
    return (
        <div className="videos-container">
            {videos.map(video =>
                (<VideoContainer removeVideoById={removeVideoById} video={video} key={video.id}/>)
            )}
            <UploadVideoContainer/>
        </div>
    );
}

VideosContainer.propTypes = {
    videos: PropTypes.array,
    removeVideoById: PropTypes.func,
};

export default VideosContainer;
